<div fxLayout="row" fxLayoutAlign="space-between start">
  <mat-form-field fxFlex>
    <mat-label [ngClass]="{ 'color-white': isLableColorWhite }"
      >{{ setting.DisplayName }}
      <span *ngIf="setting.IsMandatory" class="validation-red-color">*</span></mat-label
    >
    <mat-select
      attr.data-cy="Select {{setting.DisplayName}}"
      [panelClass]="panelClass"
      [formControl]="formCtrl"
      #singleSelect
      (selectionChange)="setValue($event.value)"
      (openedChange)="onToggleSelect($event)"
      (opened)="onMatSelectOpened()"
      (closed)="onMatSelectClosed()"
      [disabled]="isDisable || setting.IsDisableForDay2Manager"
    >
      <mat-option>
        <ngx-mat-select-search
          id="singleSelectSearch"
          [formControl]="formFilterCtrl"
          [placeholderLabel]="setting.DisplayName"
          [searching]="setting.loader"
          [disableScrollToActiveOnOptionsChanged]="true"
          (input)="onChangeValue($event.target.value)">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option attr.data-cy="Select Option None" *ngIf="!setting.IsMandatory && isNoneShow()"
        >None</mat-option
      >
      <mat-option *ngIf="formCtrl.value && !isCurrentValueInList()" [value]="formCtrl.value" style="display: none;">
        {{ getSelectedLabelFallback() }}
      </mat-option>
      <ng-container *ngIf="setting.groupOptions; else singleOption">
        <mat-optgroup *ngFor="let option of filteredValues | async" [label]="option.Label">
          <mat-option class="ml-4" *ngFor="let value of option.Value" [value]="value.Value">
            {{ value.Label | ignoreNextLine }}
          </mat-option>
        </mat-optgroup>
      </ng-container>
      <ng-template #singleOption>
        <mat-option
          attr.data-cy="Select Option {{value.Label}}"
          *ngFor="let value of filteredValues | async"
          [disabled]="value.Disabled"
          [value]="value.Value"
        >
          <ng-container *ngIf="setting.IsShowImage; else simpleOption">
            <div fxLayout="row" fxLayoutAlign="start center">
              <img
                class="option-img"
                alt=""
                *ngIf="setting.IsShowImage"
                [src]="value.Image"
                onError="this.src='assets/default/Custom/no-image-available.svg'"
              />
              <span>{{ value.Label | ignoreNextLine }}</span>
            </div>
          </ng-container>
          <ng-template #simpleOption>
            {{ value.Label | ignoreNextLine }}
          </ng-template>
        </mat-option>
      </ng-template>
    </mat-select>
    <mat-icon *ngIf="setting.loader" matPrefix>
      <mat-spinner color="accent" diameter="20"></mat-spinner>
    </mat-icon>
    <mat-icon
      color="primary"
      *ngIf="isShowRefreshButton && !setting.loader"
      [icIcon]="icAutoRenew"
      matPrefix
      (click)="onClickRefresh()"
      attr.data-cy="Select Refresh {{setting.DisplayName}}"
    ></mat-icon>
    <button
      attr.data-cy="Instruction {{setting.DisplayName}}"
      type="button"
      mat-icon-button
      matSuffix
      *ngIf="setting.Instructions"
      (click)="$event.stopPropagation(); showInfo($event.target, setting.Instructions)"
    >
      <mat-icon color="primary" [icIcon]="icHelp" height="12px" width="12px"></mat-icon>
    </button>
    <button
      attr.data-cy="Full Screen {{setting.DisplayName}}"
      type="button"
      mat-icon-button
      matSuffix
      *ngIf="setting.fullScreen"
      (click)="$event.stopPropagation(); onViewFullScreen()"
    >
      <mat-icon color="primary" [icIcon]="icSearch"></mat-icon>
    </button>
  </mat-form-field>
  <button
    type="button"
    *ngIf="setting.ShowAddButton"
    attr.data-cy="Create App Component"
    color="primary"
    mat-mini-fab
    class="ml-4 text-white"
    (click)="onClickAddButton()"
  >
    <mat-icon [icIcon]="icAdd"></mat-icon>
  </button>

   <button
    type="button"
    *ngIf="setting.ShowEditButton"
    attr.data-cy="Create App Component"
    color="primary"
    mat-raised-button
    class="ml-4 text-white button-padding"
    (click)="onClickAddButton()"
  >
    <mat-icon [icIcon]="icEdit"></mat-icon>
  </button>
</div>

<blockquote class="blockquote-error mt-0" *ngIf="isShowError()">
  <p *ngIf="!setting.ParentMissingMessage; else parentMessage">
    {{ setting.DisplayName }} is required
  </p>
  <ng-template #parentMessage>
    <p>{{ setting.ParentMissingMessage }}</p>
  </ng-template>
</blockquote>
